import React from 'react'
import './index.less'
import { useEffect, useState } from 'react'
import { getWorkRequest } from '@/server'
import { PaintingCard } from '@/components/PaintingCard'
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import {
  setShowType,
  setInfoKey,
  setInfoValue
} from '@/features/SetIndexSecondInfo/setIndexSecondInfo'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { getPaintingCardTrackStyle, usePaintingCardsPerPage } from '../paintingCardCarousel'

const dynastyList = {
  先秦: { time: '（旧石器时代～公元前221年）', content: [] },
  魏晋南北朝: { time: '（公元220年～公元589年）', content: [] },
  隋唐: { time: '（公元581年～公元907年）', content: [] },
  五代十国: { time: '（公元907年～公元979年）', content: [] },
  宋: { time: '（公元960年～公元1279年）', content: [] },
  元: { time: '（公元1279年～公元1368年）', content: [] },
  明: { time: '（公元1368年～公元1644年）', content: [] },
  清: { time: '（公元1644年～公元1911年）', content: [] },
  近现代: { time: '（公元1911年～至今）', content: [] }
}
export function Dynasty() {
  // redux获取token
  const token = useAppSelector((state) => state.login.token)
  // redux配置
  const dispatch = useAppDispatch()
  // react-router配置
  const _navigate = useNavigate()
  const cardsPerPage = usePaintingCardsPerPage()
  // 每个列表共展现作品的数目
  const perListLength = 9
  // 每个展示列表中第一个作品的 index
  const [showIndex, setShowIndex] = useState<number[]>(
    new Array(Object.keys(dynastyList).length).fill(0)
  )
  // 展示内容列表
  const [showList, setShowList] = useState<object>(dynastyList)
  // 初始化展示内容
  useEffect(() => {
    Object.keys(dynastyList).forEach((dynasty) =>
      getWorkRequest(
        {
          criteria: [
            {
              key: 'dynasty',
              value: dynasty
            }
          ],
          pages: {
            page: 1,
            size: perListLength
          }
        },
        token
      ).then((res) => {
        dynastyList[dynasty].content = res.data.content.list
        const deepClone = JSON.parse(JSON.stringify(dynastyList))
        setShowList(deepClone)
      })
    )
  }, [])
  /**
   * 向小序号翻页
   * @param id: 对应DOM的id
   * @param index: 对应DOM的位序
   * @returns
   */
  const handlePre = function (index: number) {
    const newIndex = showIndex.map((x, i) => {
      if (i === index) {
        return x - cardsPerPage < 0 ? 0 : x - cardsPerPage
      } else return x
    })
    setShowIndex(newIndex)
  }
  /**
   * 向大序号翻页
   * @param id: 对应DOM的id
   * @param index: 对应DOM的位序
   * @returns
   */
  const handleNext = function (index: number, len: number) {
    const newIndex = showIndex.map((x, i) => {
      if (i === index) {
        return Math.min(x + cardsPerPage, Math.max(0, len - cardsPerPage))
      } else return x
    })
    setShowIndex(newIndex)
  }
  // 查看详情的回调，传给二级页面相应配置
  function handleIndexSecondPage(dynasty) {
    dispatch(setShowType('painting'))
    dispatch(setInfoKey('dynasty'))
    dispatch(setInfoValue(dynasty))
    // navigate("./indexSecond")
    window.open('/indexSecond')
  }

  return (
    <div className='dynasty-container'>
      {Object.keys(showList).map((dynasty, index) => (
        <div className='dynasty'>
          <div className='dynasty-title'>
            <div className='dynasty-name'>{dynasty}</div>
            <div className='btn-box'>
              <div
                className={'btn ' + (showIndex[index] === 0 ? 'disabled' : 'abled')}
                onClick={(_e) => handlePre(index)}
              >
                <ArrowLeftOutlined
                  style={{
                    margin: 'auto',
                    color: showIndex[index] === 0 ? 'rgb(180, 179, 173)' : 'rgb(72, 66, 51)'
                  }}
                />
              </div>
              <div
                className={
                  'btn ' +
                  (showIndex[index] >= Math.max(0, showList[dynasty].content.length - cardsPerPage)
                    ? 'disabled'
                    : 'abled')
                }
                onClick={(_e) => handleNext(index, showList[dynasty].content.length)}
              >
                <ArrowRightOutlined
                  style={{
                    margin: 'auto',
                    color:
                      showIndex[index] >=
                      Math.max(0, showList[dynasty].content.length - cardsPerPage)
                        ? 'rgb(180, 179, 173)'
                        : 'rgb(72, 66, 51)'
                  }}
                />
              </div>
            </div>
          </div>
          <div className='dynasty-subtitle'>
            <div className='dynasty-time'>{showList[dynasty].time}</div>
            <div className='check-all-btn' onClick={() => handleIndexSecondPage(dynasty)}>
              查看所有画作
              <ArrowRightOutlined
                style={{
                  color: 'rgb(72, 66, 51)',
                  fontSize: '14px'
                }}
              />
            </div>
          </div>
          <div className='painting-card-viewport'>
            <div className='dynasty-content' style={getPaintingCardTrackStyle(showIndex[index])}>
              {showList[dynasty].content.map((work) => (
                <PaintingCard
                  title={work.workname}
                  dynasty={''}
                  author={work.authorname}
                  museum={work.instname}
                  image={work.encoding}
                  id={work.workid}
                />
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
